import ApiServiceV2 from 'services/apiService/apiServiceV2';

export const requestTransactionCapabilities = (documentId, controlSignal) =>
	ApiServiceV2.get({
		url: `/warehouses_transactions_docs/${encodeURIComponent(
			documentId,
		)}/capabilities`,
		controlSignal,
	});
